import { useMemo } from "react";

import { useMediaQuery } from "@/hooks";
import { conflitoLabel } from "@/modules/carga-trabalho";
import { marcaSaidaKey, SEM_MARCAS } from "@/modules/recursos/simulacao";

import { ganttScaleOf, monthMinWidth } from "../gantt-carga/gantt-scale";
import { CARGA_TRABALHO_MOBILE_QUERY } from "../gantt-carga/mobile";
import {
  LAYOUT_PRESET,
  MOBILE_ROW_MIN_HEIGHT_REM,
  ROW_MIN_HEIGHT_REM,
} from "./gantt-profissionais.constants";
import type {
  GanttProfissionaisProps,
  GanttProfissionaisViewModel,
} from "./types-gantt-profissionais";

/** Escala, altura mínima das linhas e largura dos meses do Gantt de Profissionais, para desktop ou mobile. */
export function useGanttProfissionais({
  rows,
  timeline,
  today,
  headerLabel,
  onResolverConflito,
  marcas = SEM_MARCAS,
  monthMinWidthRem,
  semAcoes = false,
}: GanttProfissionaisProps): GanttProfissionaisViewModel {
  const isMobile = useMediaQuery(CARGA_TRABALHO_MOBILE_QUERY);
  const scale = useMemo(() => ganttScaleOf(timeline), [timeline]);

  return {
    rows,
    today,
    headerLabel,
    onResolverConflito,
    marcas,
    marcaDaLinha: (row) =>
      row.items.map((item) => marcas.get(item.key)).find(Boolean) ??
      marcas.get(marcaSaidaKey(row.key)),
    rotuloConflito: conflitoLabel,
    scale,
    rowMinHeightRem: isMobile ? MOBILE_ROW_MIN_HEIGHT_REM : ROW_MIN_HEIGHT_REM,
    unitMinWidth:
      monthMinWidthRem !== undefined
        ? `${monthMinWidthRem}rem`
        : monthMinWidth(LAYOUT_PRESET, isMobile),
    comAcoes: !semAcoes,
  };
}
